export default __webpack_public_path__ + "static/media/SAS Chat Tone 2.29e1b964.mp3";